// extracted by mini-css-extract-plugin
module.exports = {"vertical":"separator_vertical__Wy2QP","horizontal":"separator_horizontal__MATf0"};